// client/src/utils/divisionPermissions.js

/**
 * Division permission utilities
 *
 * Single source of truth for division creation and editing permissions.
 * Determines what operations are allowed based on league status.
 */

import {
  canCreateDivisions as canCreateDivisionsStatus,
  DIVISION_ASSIGNMENT_EDIT_ALLOWED_STATUSES,
} from '../constants/leagueStatuses'

/**
 * Check if divisions can be created for a league based on its status
 * @param {Object} league - League object with league_status property
 * @returns {boolean} True if divisions can be created
 */
export function canCreateDivisions(league) {
  if (!league) return false
  return canCreateDivisionsStatus(league.league_status)
}

/**
 * Check if division assignments can be edited for a league based on its status
 * @param {Object} league - League object with league_status property
 * @returns {boolean} True if division assignments can be edited
 */
export function canEditDivisions(league) {
  if (!league) return false
  return DIVISION_ASSIGNMENT_EDIT_ALLOWED_STATUSES.includes(
    league.league_status,
  )
}
